export default __webpack_public_path__ + "static/media/Quote_Disable.568e0ddc.svg";